import { useState } from 'react';

let nextIdValue = 0;
export const useId = (count = 1, prefix = '') => {
  const [idList] = useState(() => {
    const ids = [];
    for (let idCount = 0; idCount < count; ++idCount) {
      const id = nextIdValue;
      ++nextIdValue;

      ids.push((prefix || '').concat(`${id}`));
    }

    return ids;
  });

  // Return a copy of the list so callers can mutate the array safely (eg. shift()).
  return [...idList];
};

export const resetId = () => {
  nextIdValue = 0;
};
